import { useRef } from "react"

import { useCreatePreviewSastGuidance } from "@/api/useSettings"
import { useTranslation } from "@/hooks/useTranslation"
import { Form } from "@/organisms/Form"
import { useActionsSastGuidance } from "@/pages/SettingsPage/application/guidance/useGuidance"
import { GuidanceForm } from "@/pages/SettingsPage/components/organisms/GuidanceForm"
import { getAsideItems, getHeaderItems } from "./helpers"

export const GuidancePage = () => {
  const actions = useActionsSastGuidance()
  const impactCtx = useCreatePreviewSastGuidance()
  const { t: tForm } = useTranslation("translation", {
    keyPrefix: "settings.kai-guidance.form"
  })

  const ref = useRef<{
    headerItems: ReturnType<typeof getHeaderItems>
    asideItems: ReturnType<typeof getAsideItems>
  } | null>(null)

  if (!ref.current)
    ref.current = {
      headerItems: getHeaderItems(),
      asideItems: getAsideItems()
    }

  const { headerItems, asideItems } = ref.current
  const { createCtx, updateCtx } = actions
  const submitting = createCtx.isPending || updateCtx.isPending

  return (
    <Form.Page
      id="guidance-kai-form"
      aside={<Form.Aside items={asideItems} />}
      header={<Form.Header items={headerItems} />}
      footer={
        <Form.Footer
          disabled={impactCtx.isPending}
          cancelRedirect={ref.current.headerItems[1].link}
          okText={() => tForm("submit")}
          submitting={submitting}
          saveGuard={() => ({
            content: tForm("saveGuard")
          })}
        />
      }
    >
      <GuidanceForm actions={actions} impactCtx={impactCtx} />
    </Form.Page>
  )
}
